import React, { useState, useEffect } from 'react';
import styles from './PlanRevisionGraphs.module.css';
import TopNRecordsLineGraph from '../TopNRecordsLineGraph/TopNRecordsLineGraph';
import {
  getDayWisePlanRevisionReasonsGraphData,
  getDayWisePlanRevisionAgenciesGraphData,
  getWeekWisePlanRevisionReasonsGraphData,
  getWeekWisePlanRevisionAgenciesGraphData,
} from '../../utils/graphDataUtils';
import { API_RESOURCE_URLS, TIME_DURATION } from '../../constants';
import { API } from '../../apis/api';
import axios from 'axios';

const PlanRevisionGraphs = ({
  plant,
  line,
  durationText,
  startDateTime,
  endDateTime,
  ...props
}) => {
  const [
    planRevisionReasonsGraphData,
    setPlanRevisionReasonsGraphData,
  ] = useState([]);
  const [
    planRevisionAgenciesGraphData,
    setPlanRevisionAgenciesGraphData,
  ] = useState([]);
  const [reasonMaxCount, setReasonMaxCount] = useState(0);
  const [agencyMaxCount, setAgencyMaxCount] = useState(0);
  const [rawData, setRawData] = useState([]);
  const [isGraphLoading, setIsGraphLoading] = useState(true);

  const fetchPlanRevisionStatisticsDataForGivenDateRange = async (
    selectedPlant,
    selectedLine,
    selectedStartDateTime,
    selectedEndDateTime,
    APICancelTokenSource,
  ) => {
    const response = await API.get(API_RESOURCE_URLS.PLAN_REVISION_STATISTICS, {
      params: {
        plant: selectedPlant,
        line: selectedLine,
        from: selectedStartDateTime,
        to: selectedEndDateTime,
      },
      cancelToken: APICancelTokenSource.token,
    });
    return response.data;
  };

  useEffect(() => {
    setIsGraphLoading(true);
    const cancelTokenSource = axios.CancelToken.source();
    fetchPlanRevisionStatisticsDataForGivenDateRange(
      plant,
      line,
      startDateTime,
      endDateTime,
      cancelTokenSource,
    )
      .then(res => setRawData(res))
      .then(setIsGraphLoading(false));
  }, [plant, line, startDateTime, endDateTime]);

  useEffect(() => {
    const [reasonMaxRecordCount, reasonGraphDataArray] =
      durationText === TIME_DURATION.LAST_SEVEN_DAYS
        ? getDayWisePlanRevisionReasonsGraphData(
            rawData,
            startDateTime,
            endDateTime,
          )
        : getWeekWisePlanRevisionReasonsGraphData(
            rawData,
            startDateTime,
            endDateTime,
          );
    setPlanRevisionReasonsGraphData(reasonGraphDataArray);
    setReasonMaxCount(reasonMaxRecordCount);

    const [agencyMaxRecordCount, agencyGraphDataArray] =
      durationText === TIME_DURATION.LAST_SEVEN_DAYS
        ? getDayWisePlanRevisionAgenciesGraphData(
            rawData,
            startDateTime,
            endDateTime,
          )
        : getWeekWisePlanRevisionAgenciesGraphData(
            rawData,
            startDateTime,
            endDateTime,
          );
    setPlanRevisionAgenciesGraphData(agencyGraphDataArray);
    setAgencyMaxCount(agencyMaxRecordCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawData]);

  return (
    <>
      <div>
        <div className={styles.innerGraphContainer}>
          <div className={styles.topNRecordsLineGraph}>
            <div className={styles.heading}>Reason (Top contributors)</div>
            <TopNRecordsLineGraph
              data={planRevisionReasonsGraphData}
              maxRecordCount={reasonMaxCount}
              isLoading={isGraphLoading}
              durationText={durationText}
              label="count"
            />
          </div>

          <div className={styles.topNRecordsLineGraph}>
            <div className={styles.heading}>Agency (Top contributors)</div>
            <TopNRecordsLineGraph
              data={planRevisionAgenciesGraphData}
              maxRecordCount={agencyMaxCount}
              isLoading={isGraphLoading}
              durationText={durationText}
              label="count"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PlanRevisionGraphs;
